import { z } from 'zod';
import { DateSchema, ObjectIdSchema } from '../base';
import { EventLoadTypes } from '../events';

export const DailyLoadSchema = z.object({
  count: z.number(),
  time: DateSchema,
  type: z.enum(EventLoadTypes),
  eventId: ObjectIdSchema.optional(),
});
export type DailyLoad = z.infer<typeof DailyLoadSchema>;

export const DailyLoadsSchema = z.array(DailyLoadSchema);
export type DailyLoads = z.infer<typeof DailyLoadsSchema>;
